import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useActiveChat from '@hooks/useActiveChat';
import useMe from '@hooks/useMe';

type ChatLike = {
  users?: Array<{ id: string; name?: string | null }> | null;
  isGroupChat?: boolean | null;
  name?: string | null;
} | null;

const useChatAvatar = () => {
  const { activeChat } = useActiveChat();
  const { me } = useMe();
  const { t } = useTranslation('shared');

  const getChatAvatarLabel = useCallback(
    (chat?: ChatLike) => {
      const useChat = chat ?? activeChat;
      const { users, isGroupChat } = useChat || {};
      if (users) {
        if (!isGroupChat) {
          const user = users?.find((user) => {
            return user.id != me?.id;
          });
          if (user) {
            return user.name;
          } else {
            if (users[0].id === me?.id) {
              return t('myDisplayName', { displayName: me.name });
            }

            return t('myDisplayName', { displayName: users[0].name });
          }
        }
      }
      return useChat?.name;
    },
    [activeChat, me?.id]
  );

  const getChatAvatarId = useCallback(
    (chatId: string) => {
      if (activeChat?.id === chatId) {
        return activeChat.avatar;
      }
      return null;
    },
    [activeChat]
  );

  return { getChatAvatarLabel, getChatAvatarId };
};

export default useChatAvatar;
